import { render } from "./Label.vue?vue&type=template&id=6aa125af&scoped=true&ts=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"

import "./Label.vue?vue&type=style&index=0&id=6aa125af&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa125af"]])

export default __exports__